// ============================================================
// セルフ利用のよくあるご質問（承認済みモック self-guide-faq の移植）
// 拠点タイプ（ロッカー/店頭のみ）に応じてQ&Aを出し分ける。
// 内容は実際の問い合わせ・事故対応（BOX無応答時の自動振替、
// お預け完了の押し忘れ等）を反映したもの。
// ============================================================
import { IoChevronBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../../compornents/Analytics';
import { useSelfSpotInfo, spotSelfType } from './selfGuideData';
import '../../css/SelfGuide.css';

export const SelfGuideFaq = () => {
  const navigate = useNavigate();
  const { lpspot, gcompany, loading } = useSelfSpotInfo();
  const back = () => navigate(-1);

  const type = spotSelfType(lpspot);
  const isLocker = type === 'locker';
  const hoursTxt = [lpspot?.business_hours, lpspot?.holiday].filter(Boolean).join('・').replace(/\n/g, '・');

  return (
    <div className="App">
      <div className="SelfGuide">
        <Analytics title="セルフ利用のよくあるご質問" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}>
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            よくあるご質問
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        {loading ? (
          <div className="sg-loading"><TailSpin stroke="#000" /></div>
        ) : (
          <div className="sg-body">
            {type === 'none' ? (
              // セルフ未対応拠点（海神）は簡潔なフォールバックのみ（直リンク流入のガード）
              <div className="sg-callout">
                お客様の担当拠点では、セルフでのお預け・お受け取りの準備中です。準備が整いましたら、アプリのお知らせでご案内いたします。
              </div>
            ) : (
            <>
            {lpspot && (
              <div className="sg-note mb-2">
                <b>{lpspot.name}</b>{gcompany?.name ? <>（担当：{gcompany.name}）</> : null}
              </div>
            )}

            {isLocker && (
              <div className="sg-faq-q">
                <b>Q. 開錠コードを入れても扉が開きません</b><br />
                そのまま少しお待ちください。別のロッカーが自動でご案内されます。それでも開かない場合は、下記の店舗へお電話ください。
              </div>
            )}
            <div className="sg-faq-q">
              <b>Q. 「お預け完了」を押し忘れました</b><br />
              アプリのホームからいつでも押せます。押していただくと店舗に通知が届き、クリーニングが始まります。
            </div>
            <div className="sg-faq-q">
              <b>Q. 何時でも使えますか？</b><br />
              {isLocker ? (
                <><b>ロッカーは24時間</b>ご利用いただけます。店頭でのお預け・お受け取りは営業時間内{hoursTxt && <>（{hoursTxt}）</>}のみです。</>
              ) : (
                <>店頭でのお預け・お受け取りは<b>営業時間内のみ</b>です{hoursTxt && <>（{hoursTxt}）</>}。定休日・休憩時間はご利用いただけません。</>
              )}
            </div>
            {isLocker && (
              <>
                <div className="sg-faq-q">
                  <b>Q. ロッカーではなく、お店で直接渡せますか？</b><br />
                  はい。<b>店舗の営業時間内</b>であれば店頭でもお預け・お受け取りいただけます。店頭で注文番号をお伝えください。営業時間外・定休日はお受けできません。
                </div>
                <div className="sg-faq-q">
                  <b>Q. 大きな荷物（ふとんなど）は入りますか？</b><br />
                  ロッカーに入らない大きさのお品物は、営業時間内に店頭へお持ちください。
                </div>
              </>
            )}

            {gcompany && (
              <div className="sg-callout">
                <b>お困りのときは</b>
                担当クリーニング店：<b>{gcompany.name}</b>
                {gcompany.contact && <><br />TEL <b>{gcompany.contact}</b>（営業時間内）</>}
              </div>
            )}

            <Link to="/self_spots" className="sg-btn-next">セルフ対応できる拠点の一覧を見る</Link>
            <Link to="/self_guide" className="sg-btn-ghost">← セルフ利用ガイドに戻る</Link>
            </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
